import {
  getBlogArticles
} from "./chunk-VFRBTVYA.mjs";

// src/hooks/blog/listing.ts
import { useQuery } from "@tanstack/react-query";
var useBlogList = (props) => {
  return useQuery({
    queryKey: ["getBlogList", props],
    queryFn: () => getBlogArticles(props)
  });
};

export {
  useBlogList
};
//# sourceMappingURL=chunk-CZ7HZWJ7.mjs.map